import React from "react";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";
import moment from "moment";

const STATUS_LABEL = { 0: "Chờ báo giá", 1: "Đã báo giá" };

export default function ModalChiTietBaoGia({ detail, onClose }) {
  if (!detail) return null;

  return (
    <div className="baogia-overlay" onClick={onClose}>
      <div className="baogia-modal" onClick={(e) => e.stopPropagation()}>
        <div className="baogia-modal-header">
          <span>Chi tiết báo giá{detail.data ? ` — ${detail.data.MaBaoGia}` : ""}</span>
          <button
            className="cart-shop-remove"
            onClick={onClose}
            style={{ padding: "4px 8px" }}
          >
            <Icon path={mdiClose} size={0.85} />
          </button>
        </div>
        <div className="baogia-modal-body">
          {detail.loading ? (
            <div className="giaodich-empty">Đang tải...</div>
          ) : !detail.data ? (
            <div className="giaodich-empty">Không có dữ liệu.</div>
          ) : (
            <>
              {(() => {
                const daBaoGia = detail.data.Approval === 1;
                const totalDL  = Number(detail.data.TotalAmountDaiLy || 0);
                const totalBG  = Number(detail.data.TotalAmount || 0);
                return (
                  <>
                    <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginBottom: 12, fontSize: 14 }}>
                      <span>Trạng thái: <b>{STATUS_LABEL[detail.data.Approval]}</b></span>
                      <span>Ngày tạo: <b>{moment(detail.data.CreatedTime).format("DD/MM/YYYY HH:mm")}</b></span>
                      {totalDL > 0 && (
                        <span>
                          Giá đại lý:{" "}
                          <b style={{ color: "#6b7280" }}>{totalDL.toLocaleString()}đ</b>
                        </span>
                      )}
                      {daBaoGia && totalBG > 0 && (
                        <span>
                          Giá báo:{" "}
                          <b style={{ color: "#ff4d00" }}>{totalBG.toLocaleString()}đ</b>
                        </span>
                      )}
                    </div>

                    <div className="giaodich-table-wrap">
                      <table className="giaodich-table">
                        <thead>
                          <tr>
                            <th className="text-center" style={{ width: 40 }}>STT</th>
                            <th className="text-left">Tên sản phẩm</th>
                            <th className="text-right" style={{ width: 75 }}>Số lượng</th>
                            <th style={{ width: 55 }}>ĐVT</th>
                            {daBaoGia && <th className="text-right" style={{ width: 110 }}>Giá báo</th>}
                            {daBaoGia && <th className="text-right" style={{ width: 110 }}>T.Tiền báo</th>}
                            <th>Ghi chú</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!(detail.data.lstChiTiet || []).length ? (
                            <tr>
                              <td colSpan={daBaoGia ? 9 : 7} className="giaodich-empty">Không có sản phẩm</td>
                            </tr>
                          ) : (
                            (detail.data.lstChiTiet || []).map((item, idx) => (
                              <tr key={idx}>
                                <td className="text-center">{idx + 1}</td>
                                <td>
                                  <div style={{ fontWeight: 600 }}>{item.CategoryName}</div>
                                  {item.OptionName && (
                                    <div style={{ fontSize: 12, color: "#6b7280" }}>{item.OptionName}</div>
                                  )}
                                </td>
                                <td className="text-right">{Number(item.Quantity || 0).toLocaleString()}</td>
                                <td>{item.DisplayName || ""}</td>
                                {daBaoGia && (
                                  <td className="text-right" style={{ color: "#ff4d00", fontWeight: 600 }}>
                                    {Number(item.DonGia || 0) === 0
                                      ? "—"
                                      : `${Number(item.DonGia).toLocaleString()}đ`}
                                  </td>
                                )}
                                {daBaoGia && (
                                  <td className="text-right" style={{ color: "#ff4d00", fontWeight: 600 }}>
                                    {Number(item.ThanhTien || 0) === 0
                                      ? "—"
                                      : `${Number(item.ThanhTien).toLocaleString()}đ`}
                                  </td>
                                )}
                                <td style={{ color: "#6b7280" }}>{item.GhiChu || ""}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                );
              })()}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
